import React from 'react';
import { Link } from 'react-router-dom';
import { Service, services } from './ServicesSection'; // Corrected import for services array

const logoUrl = "https://uploads-ssl.webflow.com/602156e042193761b5577fce/602791e97df225621c20f05c_logo_kult-io_white.svg";
const LINK_HOVER_COLOR = "#60A5FA"; // blue-400

// Define props for Footer
interface FooterProps {
  onOpenServiceModal: (service: Service) => void;
  onOpenContactModal: () => void;
}

const Footer: React.FC<FooterProps> = ({ onOpenServiceModal, onOpenContactModal }) => {

  const handleServiceClick = (serviceTitle: string) => {
    const service = services.find((s: Service) => s.title === serviceTitle); // Added type for s
    if (service) {
      onOpenServiceModal(service);
    }
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center">
              <Link to="/">
                 <img className="h-8 w-auto" src={logoUrl} alt="Kult.io Logo" />
              </Link>
            </div>
            <p className="mt-4 text-sm text-gray-400">
              AWS Solutions and Monitoring 24x7. Working with AWS cloud infrastructures since 10+ years.
            </p>
            {/* Social Media Icons - Placeholder for now, can be replaced with lucide-react or other SVG icons */}
            <div className="mt-6 flex space-x-4">
              <a href="https://www.linkedin.com/company/kult-io/" target="_blank" rel="noopener noreferrer" className="text-gray-400" style={{'--hover-color': LINK_HOVER_COLOR} as React.CSSProperties} onMouseOver={e => e.currentTarget.style.color = LINK_HOVER_COLOR} onMouseOut={e => e.currentTarget.style.color = ''}>
                <span className="sr-only">LinkedIn</span>
                {/* Placeholder SVG - replace with actual icon */}
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path fillRule="evenodd" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" clipRule="evenodd" /></svg>
              </a>
              {/* Repeat for other social icons (Twitter, GitHub) with appropriate SVGs */}
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Services</h3>
            <ul className="mt-4 space-y-3">
              <li><button onClick={() => handleServiceClick("Cloud Architecture")} className="text-base text-gray-400 hover:text-blue-400 bg-transparent border-none p-0 cursor-pointer">Cloud Architecture</button></li>
              <li><button onClick={() => handleServiceClick("DevOps & Automation")} className="text-base text-gray-400 hover:text-blue-400 bg-transparent border-none p-0 cursor-pointer">DevOps & Automation</button></li>
              <li><button onClick={() => handleServiceClick("Security & Compliance")} className="text-base text-gray-400 hover:text-blue-400 bg-transparent border-none p-0 cursor-pointer">Security & Compliance</button></li>
              <li><button onClick={() => handleServiceClick("Monitoring & Analytics")} className="text-base text-gray-400 hover:text-blue-400 bg-transparent border-none p-0 cursor-pointer">Monitoring & Analytics</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Company</h3>
            <ul className="mt-4 space-y-3">
              <li><a href="#about" className="text-base text-gray-400" style={{'--hover-color': LINK_HOVER_COLOR} as React.CSSProperties} onMouseOver={e => e.currentTarget.style.color = LINK_HOVER_COLOR} onMouseOut={e => e.currentTarget.style.color = ''}>About Us</a></li>
              <li>
                <Link 
                  to="/blog" 
                  className="text-base text-gray-400" 
                  style={{'--hover-color': LINK_HOVER_COLOR} as React.CSSProperties} 
                  onMouseOver={e => e.currentTarget.style.color = LINK_HOVER_COLOR} 
                  onMouseOut={e => e.currentTarget.style.color = ''}
                >
                  Blog
                </Link>
              </li>
              <li><button onClick={onOpenContactModal} className="text-base text-gray-400 hover:text-blue-400 bg-transparent border-none p-0 cursor-pointer">Contact</button></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Contact Us</h3>
            <address className="mt-4 space-y-3 text-base text-gray-400 not-italic">
              <p>Powstania Warszawskiego avenue 15</p>
              <p>31-539 Cracow</p>
              <p>Poland</p>
              <p><a href="mailto:info@kult.io" className="hover:text-blue-400" style={{'--hover-color': LINK_HOVER_COLOR} as React.CSSProperties} onMouseOver={e => e.currentTarget.style.color = LINK_HOVER_COLOR} onMouseOut={e => e.currentTarget.style.color = ''}>info@kult.io</a></p>
            </address>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-700 pt-8">
          <p className="text-base text-gray-400 text-center">
            © {new Date().getFullYear()} Kult.io. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 